function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import Vue from "vue";
import { computed, defineComponent, reactive, ref, watch, h, onMounted, onUpdated } from '@vue/composition-api';
import { withInstall } from '../util/index';
import { makeStringProp, makeNumericProp } from '../util/props';
import { unitToPx } from '../util/format';
import { isHidden, getScrollTop } from '../util/dom';
import { useRect } from '../util/use-rect';
import { useEventListener } from '../util/use-event-listener';
import { useVisibilityChange } from '../util/use-visibility-change';
import { useScrollParent } from '../util/use-scroll-parent';
import "../style/components/sticky.css";
export function getZIndexStyle(zIndex) {
  var style = {}; // const style: CSSProperties = {};

  if (zIndex !== undefined) {
    style.zIndex = +zIndex;
  } else {
    style.zIndex = 99;
  }

  return style;
}
var stickyProps = {
  zIndex: [Number, String],
  position: makeStringProp('top'),
  container: Object,
  offsetTop: makeNumericProp(0),
  offsetBottom: makeNumericProp(0)
};
var Sticky = defineComponent({
  name: 'm-sticky',
  props: stickyProps,
  emits: ['scroll', 'change'],
  setup: function setup(props, _ref) {
    var emit = _ref.emit,
        slots = _ref.slots,
        refs = _ref.refs;
    onMounted(function () {
      root.value = refs.root || null;
      Vue.nextTick(function () {
        root.value = refs.root || null;
      });
    });
    onUpdated(function () {
      root.value = refs.root || null;
      Vue.nextTick(function () {
        root.value = refs.root || null;
      });
    });
    var root = ref(null);
    var scrollParent = useScrollParent(root);
    var state = reactive({
      fixed: false,
      width: 0,
      height: 0,
      transform: 0
    });
    var isStickyFixed = ref(false); // CSSProperties any 先代替

    var rootStyle = computed(function () {
      var fixed = state.fixed,
          height = state.height,
          width = state.width;

      if (fixed) {
        return {
          width: "".concat(width, "px"),
          height: "".concat(height, "px")
        };
      }
    }); // CSSProperties any 先代替

    var stickyStyle = computed(function () {
      if (!state.fixed) {
        return;
      }

      var style = Object.assign(getZIndexStyle(props.zIndex), _defineProperty({
        width: "".concat(state.width, "px"),
        height: "".concat(state.height, "px")
      }, props.position, "".concat(offset.value, "px")));

      if (state.transform) {
        style.transform = "translate3d(0, ".concat(state.transform, "px, 0)");
      }

      return style;
    });
    var offset = computed(function () {
      return unitToPx(props.position === 'top' ? props.offsetTop : props.offsetBottom);
    });

    var emitScroll = function emitScroll(scrollTop) {
      emit('scroll', {
        scrollTop: scrollTop,
        isFixed: state.fixed
      });
    };

    var onScroll = function onScroll() {
      isStickyFixed.value = true;

      if (!root.value || isHidden(root)) {
        return;
      }

      var container = props.container,
          position = props.position;
      var rootRect = useRect(root);
      var scrollTop = getScrollTop(window);
      state.width = rootRect.width;
      state.height = rootRect.height;

      if (position === 'top') {
        // The sticky component should be kept inside the container element
        if (container) {
          var containerRect = useRect(container);
          var difference = containerRect.bottom - offset.value - state.height;
          state.fixed = offset.value > rootRect.top && containerRect.bottom > 0;
          state.transform = difference < 0 ? difference : 0;
        } else {
          state.fixed = offset.value > rootRect.top;
        }
      } else {
        var clientHeight = document.documentElement.clientHeight;

        if (container) {
          var _containerRect = useRect(container);

          var _difference = clientHeight - _containerRect.top - offset.value - state.height;

          state.fixed = clientHeight - offset.value < rootRect.bottom && clientHeight > _containerRect.top;
          state.transform = _difference < 0 ? -_difference : 0;
        } else {
          state.fixed = clientHeight - offset.value < rootRect.bottom;
        }
      }

      emitScroll(scrollTop);
    };

    watch(function () {
      return state.fixed;
    }, function (value) {
      emit('change', value);
    });
    useEventListener('scroll', onScroll, {});
    useVisibilityChange(root, onScroll);
    return function () {
      var _slots$default;

      return h("div", {
        "class": 'm-sticky',
        "ref": "root",
        "style": rootStyle.value
      }, [h("div", {
        "class": {
          'm-sticky-fixed': state.fixed
        },
        "style": stickyStyle.value
      }, [(_slots$default = slots["default"]) === null || _slots$default === void 0 ? void 0 : _slots$default.call(slots)])]);
    };
  }
});
withInstall(Sticky);
export default Sticky;